import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import ServiceGuidelines from "./sections/ServiceGuidelines";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <ServiceGuidelines />
      <Footer />
    </div>;
}